module.exports = __webpack_public_path__ + "media/images/icons/resize-both-9116ca514a8448cc707529af391f3f11.svg";